// FROM http://mcg.mbitson.com/#!?lightBlue=%2347b3e6&blue=%234483c4&blueGrey=%23677789&grey=%23323f4d&turq=%23356e7b&green=%2325ab6a&red=%23f22613&purple=%238f5fa0&yellow=%23f4ab34&orange=%23e65100&themename=tm3
const colours = {
  lightBlue50: '#e9f6fc',
  lightBlue100: '#c8e8f8',
  lightBlue200: '#a3d9f3',
  lightBlue300: '#7ecaee',
  lightBlue400: '#63beea',
  lightBlue500: '#47b3e6',
  lightBlue: '#47b3e6',
  lightBlue600: '#40ace3',
  lightBlue700: '#37a3df',
  lightBlue800: '#2f9adb',
  lightBlue900: '#208bd5',
  lightBlueA100: '#ffffff',
  lightBlueA200: '#daefff',
  lightBlueA400: '#a7d8ff',
  lightBlueA700: '#8dcdff',

  blue50: '#e9f0f8',
  blue100: '#c7daed',
  blue200: '#a2c1e2',
  blue300: '#7ca8d6',
  blue400: '#6096cd',
  blue500: '#4483c4',
  blue: '#4483c4',
  blue600: '#3e7bbe',
  blue700: '#3570b6',
  blue800: '#2d66af',
  blue900: '#1f53a2',
  blueA100: '#dbe9ff',
  blueA200: '#a8c8ff',
  blueA400: '#75a8ff',
  blueA700: '#5c98ff',

  blueGrey50: '#edeff1',
  blueGrey100: '#d1d6dc',
  blueGrey200: '#b3bbc4',
  blueGrey300: '#95a0ac',
  blueGrey400: '#7e8b9b',
  blueGrey500: '#677789',
  blueGrey: '#677789',
  blueGrey600: '#5f6f81',
  blueGrey700: '#546476',
  blueGrey800: '#4a5a6c',
  blueGrey900: '#394759',
  blueGreyA100: '#add1ff',
  blueGreyA200: '#7ab4ff',
  blueGreyA400: '#4798ff',
  blueGreyA700: '#2e89ff',

  grey50: '#e6e8ea',
  grey100: '#c2c5ca',
  grey200: '#999fa6',
  grey300: '#707982',
  grey400: '#515c68',
  grey500: '#323f4d',
  grey: '#323f4d',
  grey600: '#2d3946',
  grey700: '#26313d',
  grey800: '#1f2934',
  grey900: '#131b25',
  greyA100: '#68a9ff',
  greyA200: '#358bff',
  greyA400: '#026eff',
  greyA700: '#0063e7',

  turq50: '#e7eeef',
  turq100: '#c2d4d7',
  turq200: '#9ab7bd',
  turq300: '#729aa3',
  turq400: '#53848f',
  turq500: '#356e7b',
  turq: '#356e7b',
  turq600: '#306673',
  turq700: '#285b68',
  turq800: '#22515e',
  turq900: '#163f4b',
  turqA100: '#88e1ff',
  turqA200: '#55d4ff',
  turqA400: '#22c8ff',
  turqA700: '#08c1ff',

  lightGreen50: '#f9fbe7',
  lightGreen100: '#f0f5c4',
  lightGreen200: '#e6ee9c',
  lightGreen300: '#dce774',
  lightGreen400: '#d5e157',
  lightGreen500: '#cddc39',
  lightGreen600: '#c8d833',
  lightGreen700: '#c1d32c',
  lightGreen800: '#bace24',
  lightGreen900: '#aec517',
  lightGreenA100: '#fefff7',
  lightGreenA200: '#f7ffc4',
  lightGreenA400: '#f0ff91',
  lightGreenA700: '#ecff78',

  green50: '#e5f5ed',
  green100: '#bee6d2',
  green200: '#92d5b5',
  green300: '#66c497',
  green400: '#46b880',
  green500: '#25ab6a',
  green: '#25ab6a',
  green600: '#21a462',
  green700: '#1b9a57',
  green800: '#16914d',
  green900: '#0d803c',
  greenA100: '#b2ffcd',
  greenA200: '#7fffad',
  greenA400: '#4cff8c',
  greenA700: '#32ff7b',

  red50: '#fdeaea',
  red100: '#facbcb',
  red200: '#f7a9a8',
  red300: '#f48785',
  red400: '#f16d6a',
  red500: '#ef5350',
  red: '#ef5350',
  red600: '#ed4c49',
  red700: '#eb4240',
  red800: '#e83937',
  red900: '#e42927',
  redA100: '#ffffff',
  redA200: '#ffeded',
  redA400: '#ffbbba',
  redA700: '#ffa2a1',

  purple50: '#f2ecf4',
  purple100: '#ddcfe3',
  purple200: '#c7afd0',
  purple300: '#b18fbd',
  purple400: '#a077ae',
  purple500: '#8f5fa0',
  purple: '#8f5fa0',
  purple600: '#875798',
  purple700: '#7c4d8e',
  purple800: '#724384',
  purple900: '#603273',
  purpleA100: '#ebbfff',
  purpleA200: '#dc8cff',
  purpleA400: '#cc59ff',
  purpleA700: '#c440ff',

  yellow50: '#fef5e7',
  yellow100: '#fce6c2',
  yellow200: '#fad59a',
  yellow300: '#f7c471',
  yellow400: '#f6b852',
  yellow500: '#f4ab34',
  yellow: '#f4ab34',
  yellow600: '#f3a42f',
  yellow700: '#f19a27',
  yellow800: '#ef9121',
  yellow900: '#ec8015',
  yellowA100: '#ffffff',
  yellowA200: '#fff3e8',
  yellowA400: '#ffd8b5',
  yellowA700: '#ffca9c',

  orange50: '#fceae0',
  orange100: '#f8cbb3',
  orange200: '#f3a880',
  orange300: '#ee854d',
  orange400: '#ea6b26',
  orange500: '#e65100',
  orange: '#e65100',
  orange600: '#e34a00',
  orange700: '#df4000',
  orange800: '#db3700',
  orange900: '#d52700',
  orangeA100: '#fffdfc',
  orangeA200: '#ffd0c9',
  orangeA400: '#ffa396',
  orangeA700: '#ff8d7d',
  white: '#ffffff',
  black: '#131b25',
  transparent: 'transparent',
  deepOrange50: '#fbe9e7',
  deepOrange100: '#ffccbc',
  deepOrange200: '#ffab91',
  deepOrange300: '#ff8a65',
  deepOrange400: '#ff7043',
  deepOrange500: '#ff5722',
  deepOrange600: '#f4511e',
  deepOrange700: '#e64a19',
  deepOrange800: '#d84315',
  deepOrange900: '#bf360c',
  deepOrangeA100: '#ff9e80',
  deepOrangeA200: '#ff6e40',
  deepOrangeA400: '#ff3d00',
  deepOrangeA700: '#dd2c00',

  brown50: '#efebe9',
  brown100: '#d7ccc8',
  brown200: '#bcaaa4',
  brown300: '#a1887f',
  brown400: '#8d6e63',
  brown500: '#795548',
  brown600: '#6d4c41',
  brown700: '#5d4037',
  brown800: '#4e342e',
  brown900: '#3e2723'
};
// const colours = {
//   blue:'#4E7AC1',
//   blue600:'#4E7AC1',
//   blue500:'#529BD4',
//   blue400:'#6DB3E2',
//   blue300:'#94CCEE',
//   blue200:'#C4E2F5',
//   blue100:'#DFF2FB',

//   lightBlue:'#30B5E8',
//   lightBlue600:'#30B5E8',
//   lightBlue500:'#3DC5F2',
//   lightBlue400:'#64CDF5',
//   lightBlue300:'#92D9F6',
//   lightBlue200:'#C5E9F7',
//   lightBlue100:'#DFF3FB',

//   grey:'#3B4751',
//   grey600:'#3B4751',
//   grey500:'#616972',
//   grey400:'#838992',
//   grey300:'#A9B0B3',
//   grey200:'#CED4D5',
//   grey100:'#E7E9E8',

//   blueGrey:'#44637C',
//   blueGrey600:'#44637C',
//   blueGrey500:'#667E91',
//   blueGrey400:'#889AA9',
//   blueGrey300:'#A8B9C3',
//   blueGrey200:'#D1DADF',
//   blueGrey100:'#E6ECEE',

//   turq:'#33BEB6',
//   turq600:'#33BEB6',
//   turq500:'#52C2BF',
//   turq400:'#6BC9C8',
//   turq300:'#91D4D5',
//   turq200:'#C2E5E6',
//   turq100:'#DEF1F2',

//   coral:'#EF6046',
//   coral600:'#EF6046',
//   coral500:'#F27B66',
//   coral400:'#F59589',
//   coral300:'#F8B6AA',
//   coral200:'#FAD7CF',
//   coral100:'#FCE9E3',

//   yellow:'#E4A626',
//   yellow600:'#E4A626',
//   yellow500:'#E8B83F',
//   yellow400:'#ECC86B',
//   yellow300:'#F1D694',
//   yellow200:'#F7EAC4',
//   yellow100:'#FAF6E1',

//   purple:'#B04278',
//   purple600:'#B04278',
//   purple500:'#BF6691',
//   purple400:'#CE85A7',
//   purple300:'#D9A7BF',
//   purple200:'#EBD0DB',
//   purple100:'#F5E5ED',

//   red:'#D84751',
//   red600:'#D84751',
//   red500:'#DF686E',
//   red400:'#E4868D',
//   red300:'#ECA9AD',
//   red200:'#F6D1D1',
//   red100:'#F8E5E7',

//   green:'#8BC640',
//   green600:'#8BC640',
//   green500:'#9FCE5F',
//   green400:'#B3D680',
//   green300:'#C8E1A5',
//   green200:'#E1EECC',
//   green100:'#EFF6E3',

//   orange:'#F59223',
//   orange600:'#F59223',
//   orange500:'#F6A73F',
//   orange400:'#F7B869',
//   orange300:'#F9CF93',
//   orange200:'#FCE3C3',
//   orange100:'#FEF2DF',

//   white:'#fff'
// }

const setLegacyColourVariables = () => {
  const rootStyle = document.documentElement?.style;
  if (!rootStyle) {
    return;
  }

  const addVar = (name: string, value: string) => {
    rootStyle.setProperty(`--color-${name}`, value);
  };

  Object.entries(colours).forEach(([key, value]) => {
    if (typeof value !== 'string') {
      return;
    }

    // Keep legacy TM3 key names (e.g. blueGrey-500) and provide kebab aliases.
    const withShade = key.replace(/([a-zA-Z])(\d)/g, '$1-$2');
    const kebab = withShade.replace(/([a-z])([A-Z])/g, '$1-$2');

    addVar(withShade, value);
    addVar(kebab, value);

    // Provide US spelling aliases for legacy grey tokens.
    if (withShade.startsWith('grey')) {
      addVar(withShade.replace(/^grey/, 'gray'), value);
      addVar(kebab.replace(/^grey/, 'gray'), value);
    }
  });
};

export default colours;
export { colours, setLegacyColourVariables };
export { colours as Colours };
export { colours as Colors }; //material-ui replacement
